import { render, staticRenderFns } from "./FormSelectMultiple.vue?vue&type=template&id=154d3486&"
import script from "./FormSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./FormSelectMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports